import { Base } from "./Base";
import { EParagraphType, EIntention, ERequestReason, 
         ERequestPrivacy, ERequestStatus, IExif, 
         ITransactionDates, IRequestDates, IParagraph, 
         IComment, IRequest, ILocation, 
         IEdit, IStageColor, STAGE_COLOR } from "./shared/types";
import { IPoint } from "./map/types";

import { User } from "./User";
import { Job } from "./Job";
import { Paragraph } from "./Paragraph";
import { Comment } from "./Comment";

import i18n, { transformDateFull, transformDateFormatted } from "@/common/filters";
import { createDate } from "@/common/utils";
import { urls, APIID } from "@/common/http";

//import { ServiceProvider } from "./service-provider";
//import { ServiceCatalog } from "./service-catalog";

export class Request extends Base implements IRequest {
  HalloId: string = null;
  RequestNo: string;
  Title: string = 'New Request';
  ServiceProviderCode: string;
  ServiceCategoryCode: string;
  ServiceManagerId?: string;
  Owner: User;
  Intention: EIntention = EIntention.AskForService;
  Reason: ERequestReason;
  ReasonDesc: string;
  Privacy: ERequestPrivacy = ERequestPrivacy.Private;
  Status: ERequestStatus = ERequestStatus.Draft;
  Dates: IRequestDates;
  NumberOfView: number = 0;
  NumberOfLike: number = 0;
  NumberOfComment: number = 0; //total comments in server
  CoverUri: string;
  Location: ILocation = {
    Area:null,
    Longitude: null,
    Latitude: null
  };

  //Contents: Paragraph[] = [];
  //Comments: Comment[] = []; //comments fetched from server
  //Jobs: Job[] = [];

  //for display purpose
  Contents: Paragraph[] = [];
  Comments: Comment[] = [];
  Jobs: Job[] = [];

  CoverURLTimeStamp: number = (new Date()).getTime();

  protected _propertyNames = [
    'HalloId', 'RequestNo', 'Title', 'ServiceProviderCode', 'ServiceCategoryCode', 
    'Owner', 'Intentation','Reason','ReasonOthers',
    'Privacy', 'Status', 'Dates','NumberOfView','NumberOfLike','NumberOfComment',
    'CoverUri','Location','Contents','Comments','Jobs'
  ];

  private _imageLoaded: boolean = false;

  constructor(request?:IRequest) {
    super();
    this.Dates = {
      Draft: null
    };
    if (request) {
      this.Properties = request;
    }
  }

  get Properties() : IRequest {
    return <IRequest>this.getProperties();
  }

  set Properties(request: IRequest) {
    for (let p in request) {
      if (p=='Owner') {
        this[p] = new User();
        this[p].Properties = request[p];
      //} else if (p=="ServiceProvider") {
      //  this[p] = new ServiceProvider(request[p]);
      //} else if (p=="ServiceCategory") {
      //  this[p] = new ServiceCatalog(request[p]);
      } else if (p=="Contents") {
        this[p] = [];
        request[p].forEach((paragraph) => {
          let c:Paragraph = new Paragraph(paragraph);
          c.Request = this;
          this[p].push(c);
        }, this);
      } else if (p=='Jobs') {
        this[p] = [];
        request[p].forEach((job) => {
          let j:Job = new Job(job);
          j.Request = this;
          this[p].push(j);
        }, this);
      } else if (p=="Comments") {
        this[p] = [];
        request[p].forEach((comment) => {
          let c:Comment = new Comment(comment);
          c.Request = this;
          this[p].push(c);
        }, this);
      } else if (this._propertyNames.indexOf(p) != -1) {
        this[p] = request[p];
      }
    }
  }

  set PropertiesFromStorage(request:any) {
    if (request.id && request.id!=this.HalloId) {
      this.HalloId = request.id;
    }
    if (request.request_no && request.request_no!=this.RequestNo) {
      this.RequestNo = request.request_no;
    }
    if (request.title && request.title!=this.Title) {
      this.Title = request.title;
    }
    if (request.provider_code && request.provider_code!=this.ServiceProviderCode) {
      this.ServiceProviderCode = request.provider_code;
    }
    if (request.catalog_code && request.catalog_code!=this.ServiceCategoryCode) {
      this.ServiceCategoryCode = request.catalog_code;
    }
    if (request.manager_id && request.manager_id!=this.ServiceManagerId) {
      this.ServiceManagerId = request.manager_id;
    }

    let mapping:any;
    let p;
    if (request.owner) {
      this.Owner = this.Owner || new User();
      this.Owner.PropertiesFromStorage = request.owner;
    }
    //Intention: null,
    
    if (request.reason_em && request.reason_em!=this.Reason) {
      this.Reason = parseInt('0'+request.reason_em);
    }
    if (request.reason_desc && request.reason_desc!=this.ReasonDesc) {
      this.ReasonDesc = request.reason_desc;
    }
    if (request.privacy && request.privacy!=this.Privacy) {
      this.Privacy = parseInt('0'+request.privacy);
    }
    if (request.status_em && request.status_em!=this.Status) {
      this.Status = request.status_em;
    }
    this.Dates = this.Dates || {};
    mapping = {
      create_ts: 'Sent',
      update_ts: 'Updated',
      return_ts: 'Returned',
      refuse_ts: 'Refused',
      accept_ts: 'Accepted',
      assign_ts: 'Assigned',
      prepare_ts: 'Preparing',
      implement_ts: 'Implementing',
      done_ts: 'Done',
      close_ts: 'Closed'
    };
    for (p in mapping) {
      if (request[p]) {
        this.Dates[mapping[p]] = createDate(request[p]);
      }
    }
    request.num_of_view = request.num_of_view || request.view_nn;
    if (request.num_of_view && request.num_of_view!=this.NumberOfView) {
      this.NumberOfView = request.num_of_view;
    }
    request.num_of_like = request.num_of_like || request.like_nn;
    if (request.num_of_like && request.num_of_like!=this.NumberOfView) {
      this.NumberOfLike = request.num_of_like;
    }
    if (request.num_of_comment && request.num_of_comment!=this.NumberOfComment) {
      this.NumberOfComment = request.num_of_comment;
    }
    if (request.media_path && request.media_path!=this.CoverUri) {
      this.CoverUri = request.media_path;
      this.CoverURLTimeStamp = (new Date()).getTime();
    }
    this.Location = this.Location || {};
    mapping = {
      location: 'Area',
      lon_wgs84: 'Longitude',
      lat_wgs84: 'Latitude'
    };
    for (p in mapping) {
      if (request[p] && request[p]!=this.Location[mapping[p]]) {
        this.Location[mapping[p]] = request[p];
      }
    }
    /*this.Location = {
      Area: request.location || this.Location.Area,
      Longitude: request.lon_wgs84 || this.Location.Longitude,
      Latitude: request.lat_wgs84 || this.Location.Latitude
    };*/
  }

  //updateRecentComments() {
  get RecentComments() : Comment[] {
    let cmts:Array<Comment> = [];
    let i, n = Math.min(this.Comments.length, 5);
    for (i=0; i<n; i++) {
      cmts.push(this.Comments[i]);
    }
    return cmts;
  }

  get isOtherReason() : boolean {
    return (this.Reason && this.Reason==ERequestReason.Others);
  }

  VisibleAction:number = -1;
  setActionVisibility(action:number) {
    if (action != this.VisibleAction) {
      let oldAction = this.VisibleAction;
      this.VisibleAction = action;
    }
  }

  get ActionVisibility1() : string {
    return (this.VisibleAction!=this.Contents.length) ? 'visible' : 'collapsed';
  }

  get ActionVisibility2() : string {
    return (this.VisibleAction==this.Contents.length) ? 'visible' : 'collapsed';
  }

  get CoverURL() : string {
    if (!this.CoverUri) {
      return null;
    //} else if (this.CoverUri instanceof MediaAsset) {
    //  return this.CoverUri;
    } else if (this.CoverUri.indexOf('/' + this.HalloId)>=0) {
      //let url = urls.request.url + '/image/request/' + this.HalloId + 
      //          '?APIID=' + APIID + '&width=' + Math.ceil(getDisplayWidth());
      let url = urls.request.url + '/image/' + this.CoverUri + 
                '?APIID=' + APIID + '&width=' + Math.ceil(this.DisplayWidth) +
                '&ts=' + this.CoverURLTimeStamp;
      return url;
    }
    return this.CoverUri;
  }

  get FirstPhoto() : string {
    let i:number;
    let p:Paragraph = null;
    if (this.Contents) {
      for (i=0; i<this.Contents.length; i++) {
        p = this.Contents[i];
        if (p.SourceUri) {
          break;
        } else {
          p = null;
        }
      }
    }
    if (p) {
      return p.MediaURL;
    }
    return '';
  }
  
  get CardRows() : string {
    //return (screen.getDisplayWidth() * 9 / 16) + ',auto';
    return '*,auto'; //TODO?
  };

  get isUpdated() : boolean {
    return true;
  }

  get hasClosed() : boolean {
    return this.Status==ERequestStatus.Closed;
  }

  get isNew() : boolean {
    return this.Status == ERequestStatus.Draft;
  }

  get isRefused() : boolean {
    return this.Status==ERequestStatus.Refused || (
      this.Status==ERequestStatus.Closed && !!this.Dates.Refused
    );
  }

  get isOfficials() : boolean {
    //if (global && global.myGlobals && global.myGlobals.user) {
    //  return global.myGlobals.user.isOfficials;
    //}
    return false;
  }

  get Color():IStageColor {
    return STAGE_COLOR;
  }
  
  get Stage() : string {
    let stage: string;
    switch (this.Status) {
      case ERequestStatus.Draft:
        stage = 'Draft'; break;
      case ERequestStatus.Sent:
      case ERequestStatus.Returned:
        stage = 'New'; break;
      case ERequestStatus.Refused:
        stage = 'Refused'; break; //grey
      case ERequestStatus.Accepted:
        stage = 'Accepted'; break; //orange
      case ERequestStatus.Assigned:
      case ERequestStatus.Preparing:
      case ERequestStatus.Implementing:
        stage = 'Implementing'; break; //yellow
      case ERequestStatus.Done:
        stage = this.isOfficials ? 'Done' : 'Implementing'; break;
      case ERequestStatus.Closed:
        stage = this.Dates.Refused ? 'Refused' : 'Closed'; break;
    }
    return stage;
  }

  get StageText() : string {
    return i18n.L('stage' + this.Stage);
  }

  get StageColor() : string {
    let color: string;
    switch (this.Status) {
      case ERequestStatus.Draft:
        color = '#2E86C1'; break; //blue
      case ERequestStatus.Sent:
      case ERequestStatus.Returned:
        color = '#E74C3C'; break; //red
      case ERequestStatus.Refused:
        color = '#85929E'; break; //grey
      case ERequestStatus.Accepted:
        color = '#E67E22'; break; //orange
      case ERequestStatus.Assigned:
      case ERequestStatus.Preparing:
      case ERequestStatus.Implementing:
        color = '#FAE007'; break; //yellow
      case ERequestStatus.Done:
        let user:User = new User();
        color = user.isCitizens ? '#FAE007' : '#96FA07'; break; //Citizen:yellow, Else:yellow-green
      case ERequestStatus.Closed:
        color = this.Dates.Refused ? '#85929E' : '#07B321'; break; //grey || green
    }
    return color;
  }

  get StatusIcon() : string {
    let icon: string;
    if (this.Status==ERequestStatus.Draft) {
      icon = 'edit';
    } else if (this.Status==ERequestStatus.Sent) {
      icon = 'envelope_o';
    } else if (this.Status==ERequestStatus.Returned) {
      icon = 'undo';
    } else if (this.Status==ERequestStatus.Refused) {
      icon = 'ban';
    } else if (this.Status==ERequestStatus.Accepted) {
      icon = 'envelope_open_o';
    } else if (this.Status == ERequestStatus.Assigned) {
      icon = 'exchange';
    } else if (this.Status == ERequestStatus.Preparing || 
               this.Status == ERequestStatus.Implementing) {
      icon = 'hourglass_half';
    } else if (this.Status == ERequestStatus.Done) {
      icon = 'chart_bar';
    } else { //closed
      icon = 'handshake_o';
    }
    //return getIcon().fa[icon];
    return icon;
  }

  get NumberOfCommentText() : string {
    let n = this.Comments ? this.Comments.length : this.NumberOfComment;
    return (n==0) ? '' : '(' + n + ')';
  }

  get SubTitle() : string {
    let t = i18n.L('requestNo') + this.RequestNo;
    if (this.Dates.Sent) {
      let lang = this.DeviceLanguage;
      t += ', ' + i18n.L('submittedOn') + (lang=='en' ? ' ' : '') + i18n.DT(this.Dates.Sent);
    }
    return t;
  }

  get StatusDateFull() : string {
    return this.Dates.Sent ? transformDateFull(this.Dates.Sent) : '';
  }
 
  get StatusDateFormatted() : string {
    return transformDateFormatted(this.Dates[ERequestStatus[this.Status]], 'yyyy-MM-dd hh:mm');
  }
  
  get ServiceTypeCode() : string {
    if (this.ServiceCategoryCode) {
      let scs = this.ServiceCategoryCode.split('.');
      return scs[scs.length-1];
    }
    return null;
  }

  get StatusText() : string {
    return (this.Status==ERequestStatus.Sent && this.isOfficials) ? 'New' : ERequestStatus[this.Status];
  }

  get LatLong() : IPoint {
    let p:IPoint = null;
    if (this.HasCoordinate) {
      p = {
        Longitude: Math.round(parseFloat(this.Location.Longitude+'') * 1000000) / 1000000,
        Latitude: Math.round(parseFloat(this.Location.Latitude+'') * 1000000) / 1000000
      };
    }
    return p;
  }

  get HasCoordinate() : boolean {
    return !!this.Location && 
           !(this.Location.Longitude==undefined || this.Location.Longitude==null) && 
           !(this.Location.Latitude==undefined || this.Location.Latitude==null);
  }

  get HasBeenAssigned() : boolean {
    return this.Jobs && (this.Jobs.length>0);
  }

  get HasImageContent() : boolean {
    let b:boolean = false;
    let p:Paragraph;
    if (this.Contents) {
      for (let i=0; i<this.Contents.length; i++) {
        p = this.Contents[i];
        if (p.Type==EParagraphType.Image && p.SourceUri) {
          b = true;
          break;
        }
      }
    }
    return b;
  }

  get HasTextContent() : boolean {
    let b:boolean = false;
    let p:Paragraph;
    if (this.Contents) {
      for (let i=0; i<this.Contents.length; i++) {
        p = this.Contents[i];
        if (p.Type==EParagraphType.Text && (p.Text+'').trim()) {
          b = true;
          break;
        }
      }
    }
    return b;
  }

  get ServiceLocation() : string {
    let s:string = '';
    let d:string = String.fromCodePoint(parseInt('00B0',16));
    let language = this.DeviceLanguage;
    let loc = this.LatLong;

    if (language=='zh') {
      if (this.Location.Area) {
        s  = i18n.L('locatedIn');
        s += this.Location.Area.Name + i18n.L('province');
        if (this.Location.Area.SubArea) {
          s += this.Location.Area.SubArea.Name + i18n.L('county');
          if (this.Location.Area.SubArea.SubArea) {
            s += this.Location.Area.SubArea.SubArea.Name + i18n.L('town');
          }
        }
      }
      if (loc) {
        s += i18n.L(['nearTo','coordinate']);
        if (loc.Longitude>=0) {
          s += i18n.L('lonEast');
        } else {
          s += i18n.L('lonWest');
        }
        s += loc.Longitude + d + i18n.L('comma');
        if (loc.Latitude>=0) {
          s += i18n.L('latNorth');
        } else {
          s += i18n.L('latSouth');
        }
        s += loc.Latitude + d;
      }
    } else if (language=='th') {
      if (this.Location.Area) {
        s = i18n.L('locatedIn');
        if (this.Location.Area.SubArea) {
          if (this.Location.Area.SubArea.SubArea) {
            s += i18n.L('town') + this.Location.Area.SubArea.SubArea.Name + ' ';
          }
          s += i18n.L('county') + this.Location.Area.SubArea.Name + ' ';
        }
        s += i18n.L('province') + this.Location.Area.Name;
        s += ' ';
      }
      if (loc) {
        s += i18n.L(['nearTo','coordinate','latitude']);
        s += ' ' + loc.Latitude + d; // + ' ';
        if (loc.Latitude>=0) {
          s += i18n.L('latNorth');
        } else {
          s += i18n.L('latSouth');
        }
        s += ' ' + i18n.L('longitude') + ' ' + loc.Longitude + d;// + ' ';
        if (loc.Longitude>=0) {
          s += i18n.L('lonEast');
        } else {
          s += i18n.L('lonWest');
        }
      }
    } else {
      let comma = '';
      if (this.Location.Area) {
        s  = i18n.L('locatedIn') + ' ';
        if (this.Location.Area.SubArea) {
          if (this.Location.Area.SubArea.SubArea) {
            s += this.Location.Area.SubArea.SubArea.Name + ' ' + i18n.L('town') + ', ';
          }
          s += this.Location.Area.SubArea.Name + ' ' + i18n.L('county') + ', ';
        }
        s += this.Location.Area.Name + ' ' + i18n.L('province');
        comma = ', ';
      }
      if (loc) {
        s += i18n.L([comma,'nearTo','coordinate','latitude']);
        s += ' ' + loc.Latitude + d;
        if (loc.Latitude>=0) {
          s += i18n.L('latNorth');
        } else {
          s += i18n.L('latSouth');
        }
        s += i18n.L([', ','longitude']) + ' ' + loc.Longitude + d;
        if (loc.Longitude>=0) {
          s += i18n.L('lonEast');
        } else {
          s += i18n.L('lonWest');
        }
      }
    }
    return s;
  }

  get ImageLoaded() : boolean {
    return this._imageLoaded;
  }

  onImageLoaded(args) {
    //it takes time to render the image even after it has been loaded
    //so we do it using timeout to give some time to wait for that
    //set the activity indicator beneath the image and give the timeout long enough
    //so the image will cover to hide the activity indicator once it is shown
    //let request = args.view.bindingContext;
    setTimeout(() => {
      this._imageLoaded = true;
    }, 4000);
  }

  getContentIndex(contentId:string) : number {
    let index = -1;
    if (this.Contents && this.Contents.length>0) {
      for (let i=0; i<this.Contents.length; i++) {
        if (this.Contents[i].HalloId==contentId) {
          index = i;
          break;
        }
      }
    }
    return index;
  }
  
  getCommentIndex(commentId:string) : number {
    let index = -1;
    if (this.Comments && this.Comments.length>0) {
      for (let i=0; i<this.Comments.length; i++) {
        if (this.Comments[i].HalloId==commentId) {
          index = i;
          break;
        }
      }
    }
    return index;
  }
  
  getJobIndex(jobId:string) : number {
    let index = -1;
    if (this.Jobs && this.Jobs.length>0) {
      for (let i=0; i<this.Jobs.length; i++) {
        if (this.Jobs[i].HalloId==jobId) {
          index = i;
          break;
        }
      }
    }
    return index;
  }

  clone() : Request {
    //clone this to a new request for edit
    return new Request(this.Properties);
  }
}
